export default __webpack_public_path__ + "static/media/169.853cdb74.jpg";